import React from "react";
import { object } from "prop-types";
import { ResponsiveImage, WithLazy } from "@quintype/components";
// import get from "lodash/get";

import "./hero-image.m.css";

const HeroImage = ({ story, showImageCaption = false }) => {
  if (!story["hero-image-s3-key"]) {
    return null;
  }

  return (
    <WithLazy margin="20px">
      {() => (
        <div styleName="image-container" className="pv-story-image">
          <figure styleName="qt-image-16x9">
            <ResponsiveImage
              slug={decodeURIComponent(story["hero-image-s3-key"])}
              metadata={story["hero-image-metadata"]}
              aspectRatio={[16, 9]}
              defaultWidth={480}
              widths={[250, 480, 640]}
              imgParams={{ auto: ["format", "compress"], fmt: "webp" }}
              alt={story["hero-image-attribution"] || story["hero-image-caption"] || ""}
            />
          </figure>
          {showImageCaption && story["hero-image-caption"] && (
            <>
              <figcaption styleName="caption" dangerouslySetInnerHTML={{ __html: story["hero-image-caption"] }} />
              {story["hero-image-attribution"] && (
                <span
                  styleName="attribute"
                  dangerouslySetInnerHTML={{ __html: `${story["hero-image-attribution"]}` }}
                />
              )}
            </>
          )}
        </div>
      )}
    </WithLazy>
  );
};

HeroImage.propTypes = {
  story: object
};

export default HeroImage;
